import { ConversionBreakdown, RevenueBreakdown } from './FunnelBreakdown';
import { z } from 'zod';

export interface SourceBreakdown {
  conversion: ConversionBreakdown;
}

export interface RevenueSourceBreakdown extends SourceBreakdown {
  revenue: RevenueBreakdown;
}

export interface MatchedSourceBreakdown extends SourceBreakdown {
  costPer: number;
  rate: number;
}

export const ExtrapolationTypeSchema = z.enum([
  'Disabled',
  'Legacy',
  'Classic',
  'Modern',
]);

export type ExtrapolationType = z.infer<typeof ExtrapolationTypeSchema>;

export interface Source {
  name: string;
  desc: string;
  total: SourceBreakdown;
  attributed: SourceBreakdown;
  extrapolated: SourceBreakdown;
  extrapolationType: ExtrapolationType;
  matched: MatchedSourceBreakdown;
}
